module.exports = __webpack_public_path__ + "img/chicken.9e9c9c23.png";